"use strict";
/* globals module */
/**
 * @module articleSubscriptionsCommentRequiresModerationRoute
 * @description Baasic Article Subscriptions Comment Requires Moderation Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Subscriptions Comment Requires Moderation Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var ArticleSubscriptionsCommentRequiresModerationRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleSubscriptionsCommentRequiresModerationRoute, _super);
    function ArticleSubscriptionsCommentRequiresModerationRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.subscribeRoute = 'articles/subscriptions/comment-requires-moderation';
        _this.isSubscribedRoute = 'articles/subscriptions/comment-requires-moderation/{subscriberId}';
        _this.unSubscribeRoute = 'articles/subscriptions/comment-requires-moderation';
        return _this;
    }
    /**
     * Parses commentRequiresModeration subscribe route which doesn't support any additional options.
     * @method
     * @param data The subscribe information.
     * @example articleSubscriptionsCommentRequiresModerationRoute.subscribe(data);
     **/
    ArticleSubscriptionsCommentRequiresModerationRoute.prototype.subscribe = function (data) {
        return _super.prototype.baseCreate.call(this, this.subscribeRoute, data);
    };
    /**
     * Parses commentRequiresModeration isSubscribed route which must be expanded with subscriber Id.
     * @method
     * @param data The subscribe information.
     * @example articleSubscriptionsCommentRequiresModerationRoute.isSubscribed({subscriberId: '<subscriber-id>'});
     **/
    ArticleSubscriptionsCommentRequiresModerationRoute.prototype.isSubscribed = function (data) {
        return _super.prototype.baseCreate.call(this, this.isSubscribedRoute, data);
    };
    /**
     * Parses commentRequiresModeration unSubscribe route which doesn't support any additional options.
     * @method
     * @param data The unsubscribe information.
     * @example articleSubscriptionsCommentRequiresModerationRoute.unSubscribe(data)
     **/
    ArticleSubscriptionsCommentRequiresModerationRoute.prototype.unSubscribe = function (data) {
        return _super.prototype.baseCreate.call(this, this.unSubscribeRoute, data);
    };
    var _a;
    ArticleSubscriptionsCommentRequiresModerationRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleSubscriptionsCommentRequiresModerationRoute);
    return ArticleSubscriptionsCommentRequiresModerationRoute;
}(common_1.BaseRoute));
exports.ArticleSubscriptionsCommentRequiresModerationRoute = ArticleSubscriptionsCommentRequiresModerationRoute;
